import { I18n } from "@assets/strings";
import { List } from "immutable";
import React, { useState } from "react";
import styled from "styled-components";
import { Group, MAX_SHAREROOM_MEMBER } from "@domain/group/group";
import { Person } from "@domain/user/user";
import { useAsync } from "@utils/hooks";
import { ClosableModal } from "@ui/modals/closableModal";
import { gap } from "@ui/styles/utils";
import { LoadingButton } from "@ui/components/buttons/loadingButton";
import { useAdminLimitModal } from "@ui/components/group/shareroom/useAdminLimitModal";
import { UserSearchEngine } from "@ui/components/search/userSearchEngine";

interface EditMembersModalProps extends React.HTMLAttributes<HTMLDivElement> {
	close: () => void;
	onMembersChosen: (members: List<string>) => void | Promise<void>;
	title: string;
	group?: Group;
	organizationId?: string;
}
export const EditMembersModal: React.FC<EditMembersModalProps> = ({
	close,
	onMembersChosen,
	title,
	group,
	organizationId,
	...htmlProps
}) => {
	const [newMembers, setNewMembers] = useState<List<Person>>(List());

	const { run, loading: submitLoading } = useAsync(async () => {
		await onMembersChosen(newMembers.map(({ id }) => id));
	}, [newMembers]);

	const openLimitModal = useAdminLimitModal();

	return (
		<Container title={title} {...htmlProps} close={close} keyboardEventDisabled>
			<UserSearchEngine
				newUsers={newMembers}
				onNewUsersChange={(users, action) => {
					if (group?.type === "SHAREROOM" && newMembers.size >= MAX_SHAREROOM_MEMBER && action === "ADD") {
						openLimitModal();
						return;
					}
					setNewMembers(users);
				}}
				groupId={group?.id}
				organizationId={organizationId}
			/>
			<LoadingButton loading={submitLoading} onClick={run}>
				{I18n.t("validate")}
			</LoadingButton>
		</Container>
	);
};

const Container = styled(ClosableModal)`
	${gap(40)};
	> button {
		margin: 20px auto 0;
	}
`;
